/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cad_Features_Precision_TitleInputs */

const en_cad_features_precision_title = /** @type {(inputs: Cad_Features_Precision_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Draft with precision`)
};

/**
* | output |
* | --- |
* | "Draft with precision" |
*
* @param {Cad_Features_Precision_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const cad_features_precision_title = /** @type {((inputs?: Cad_Features_Precision_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cad_Features_Precision_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_cad_features_precision_title(inputs)
});
export { cad_features_precision_title as "cad.features.precision_title" }